const SortingValues = {
    RELEVANCE: 'relevance',
    SPECIAL_DEALS: 'promo',
    PRICE: 'price',
    BRANDS: 'manufacturer',
};

export { SortingValues };